import React from "react";
import { Skeleton, Stack } from "@mui/material";

const SkeletonFiles = () => {
  const widthInput = 100;
  const heightInput = 40;

  return (
    <Stack direction="row" spacing={2}>
      <Skeleton variant="text" width={widthInput} height={heightInput} />
      <Skeleton variant="text" width={widthInput} height={heightInput} />
      <Skeleton variant="text" width={widthInput} height={heightInput} />
      <Skeleton variant="text" width={widthInput} height={heightInput} />
      <Skeleton variant="text" width={widthInput} height={heightInput} />
      <Skeleton variant="text" width={widthInput} height={heightInput} />
    </Stack>
  );
};

const SkeletonEditor = () => {
  return (
    <Skeleton
      style={{ marginTop: "16px" }}
      variant="rectangular"
      width="100%"
      height="255px"
    />
  );
};

export { SkeletonFiles, SkeletonEditor };
